<header class="header bg_color_white">
    <div class="container">
        <div class="header_flex row row_jc_space_btw">
            <app-search-bar></app-search-bar>
            <div class="notification_container row">
                <button disabled type="button" class="notification transition row">
                    <span class="material-symbols-outlined color_light_gray bell transition">
                        notifications
                    </span>
                </button>
                <button type="button" class="avatar_container row">   
                    <div class="avatar row row_ai_center row_jc_center transition fz_l color_white" style="background-image: url('{{user.profileImage}}');">{{user.profileImage ? '' : userFirstName+userLastName}}</div>
                    <!-- <div class="avatar transition fz_l row row_ai_center row_jc_center color_violet">{{userFirstName}}{{userLastName}}</div> -->
                    <span class="material-symbols-outlined color_light_gray">
                        keyboard_arrow_down
                    </span>
                </button>
            </div>
        </div>
    </div>
</header>
